export const Marquee = ({ items, reverse = false, className = "", testid }) => {
  const doubled = [...items, ...items];
  return (
    <div data-testid={testid} className={`overflow-hidden ${className}`}>
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-4xl italic text-ink md:text-6xl lg:text-7xl">{item}</span>
            <span className="mx-8 text-terracotta md:mx-14">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden>
                <path d="M7 0l1.8 5.2L14 7l-5.2 1.8L7 14l-1.8-5.2L0 7l5.2-1.8z" />
              </svg>
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
